import { css } from "styled-components";

export default {
    defaultProps: {
        buttonProps: {
            css: css`
                min-width: 40px;
            `,
        },
    },
};
